import { notification } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { Button } from "@rumbledirect/ui";
import { exportDossiersBySlug } from "@/lib/api/resources/dossiers";

const EXPORT_DEFINITION_SLUG = "dossiers-export-damage-number-filtered-excel";

export const DossiersExportButton = () => {
  const exportMutation = useMutation({
    mutationFn: () => exportDossiersBySlug(EXPORT_DEFINITION_SLUG),
    onError: () => {
      notification.error({
        message: "Exporteren mislukt",
        description: "Er ging iets mis bij het exporteren van de dossiers.",
      });
    },
  });

  return (
    <Button
      icon={<ExportOutlined />}
      onClick={() => exportMutation.mutate()}
      loading={exportMutation.isPending}
      variant="light"
    >
      Dossiers zonder schadenummer exporteren
    </Button>
  );
};
